import { type UseQueryResult, useQuery } from 'react-query';
import {
  MyHoldingsOverviewService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto,
} from '../../services/wealthlane-award-services';

const useGetMyHoldingOverview = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean | undefined
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto | undefined,
  unknown
> => {
  const myHoldingOverview = useQuery(
    ['getMyHoldingOverview'],
    async () => {
      return await handleRequest(
        MyHoldingsOverviewService.getApiAwardApiAppMyHoldingsOverviewHoldings()
      );
    },
    {
      enabled: Boolean(enabled),
    }
  );

  return myHoldingOverview;
};

export default useGetMyHoldingOverview;
